import React from 'react';
import { IconProps } from '.';

const SvgInspection = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        d='M9.249 2.25h.8V3c0 .426.179.741.49.972.33.246.836.41 1.46.41.626 0 1.132-.164 1.462-.41A1.15 1.15 0 0 0 13.95 3v-.75h.8c.638 0 1.302 0 1.976.212.717.227 1.383.67 2.117 1.443.84.883 1.48 2.406 1.942 3.832A28.91 28.91 0 0 1 21.622 11h-1.53c-.17-.82-.418-1.822-.734-2.802-.458-1.415-1.017-2.645-1.602-3.26-.615-.648-1.074-.916-1.482-1.045-.282-.09-.569-.123-.926-.135a2.655 2.655 0 0 1-.991 1.417c-.647.482-1.491.707-2.357.707-.867 0-1.71-.225-2.357-.707a2.655 2.655 0 0 1-.991-1.417c-.358.012-.644.046-.926.135-.408.129-.867.397-1.482 1.045-.585.615-1.144 1.845-1.602 3.26a27.413 27.413 0 0 0-.802 3.14l2.01.917V9.632h1.5V20.25H11v1.5H5.85v-7.847l-3.682-1.68.091-.564c.156-.96.483-2.461.956-3.922.46-1.426 1.102-2.95 1.941-3.832.735-.774 1.401-1.216 2.118-1.443.674-.212 1.337-.212 1.975-.212Z'
      />
      <path fill={color} d='M14 9.75h-4v-1.5h4v1.5Z' />
      <path
        fill={color}
        fillRule='evenodd'
        d='M17.5 13.25a4.25 4.25 0 1 0 2.428 7.739l2.607 2.607 1.061-1.06-2.607-2.608A4.25 4.25 0 0 0 17.5 13.25Zm-2.75 4.25a2.75 2.75 0 1 1 5.5 0 2.75 2.75 0 0 1-5.5 0Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgInspection;
